import { useMemo } from 'react';

import {
  useFetchModelInstancesCursorPagination,
  type IModelInstance,
} from '../../../ui-builder';

/**
 * Fetches the IDMPs belonging to a Medicinal Product Family. The family holds
 * no member list — the link lives on the IDMP (`productFamily`) — so members
 * are found by filtering IDMP instances on that reference.
 *
 * `idmpModelId` comes from a reference already on the ePI rather than a
 * constant, so the query follows whatever model those references point at.
 * Disabled until both ids are known.
 */
export const useFetchFamilyIdmps = (
  familyId: string | undefined,
  idmpModelId: string | undefined
) => {
  const enabled = !!familyId && !!idmpModelId;

  const { modelInstances, isLoadingModelInstances } =
    useFetchModelInstancesCursorPagination({
      params: {
        modelIds: idmpModelId ? [idmpModelId] : undefined,
        filters: familyId
          ? JSON.stringify({ '==': [{ var: 'productFamily.id' }, familyId] })
          : undefined,
        size: 200,
      },
      options: { enabled, placeholderData: prev => prev },
    });

  const familyIdmps = useMemo<IModelInstance[]>(
    () => modelInstances?.data ?? [],
    [modelInstances]
  );

  return { familyIdmps, isLoadingFamilyIdmps: isLoadingModelInstances };
};
